import { Input, Box, Text } from '@chakra-ui/react';
import React from 'react';
import NumberFormat from 'react-number-format';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { useEventContext } from '../provider';
import { useCheckoutFormValuesStore } from '../stores';
import { useCheckoutWalletByIdQuery } from 'src/hooks/queries/checkout';
import { useParams } from 'react-router-dom';

const CheckoutConfirmCard = () => {
  const {
    // eventID,
    paymentMethodId,
  } = useParams();

  const { data, isLoading, isError } = useCheckoutWalletByIdQuery(
    paymentMethodId ?? '',
  );
  const { invalidFieldsNames, invalidFieldsMessage } = useEventContext();
  const { formValues, setFormValues } = useCheckoutFormValuesStore();

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const amountCharged = event.target.value;
    setFormValues({ amountCharged });
  };

  React.useEffect(() => {
    setFormValues({ amountCharged: '' });
  }, [setFormValues]);

  // TODO: insert spinner/skeleton
  if (isLoading) {
    return null;
  }

  // TODO: insert try again screen
  if (isError) {
    return null;
  }

  return (
    <Box w="full" mx="auto" pb="8">
      <Text>
        {'Fizemos uma pequena cobrança no seu cartão '}
        <Text as="b">{`(final ${data?.name})`}</Text>
        {` em ${format(new Date(data?.createdAt ?? ''), 'dd/MM/yyyy', {
          locale: ptBR,
        })}. Confira sua fatura e informe o valor cobrado abaixo. Faremos estorno após confirmação.`}
      </Text>
      <Box my="20">
        <NumberFormat
          prefix="R$ "
          format="R$ #,##"
          decimalSeparator=","
          thousandSeparator="."
          allowNegative={false}
          allowLeadingZeros={false}
          decimalScale={2}
          isInvalid={invalidFieldsNames.includes('amountCharged')}
          customInput={Input}
          placeholder="R$ 0,00"
          fontSize="4xl"
          fontWeight="bold"
          textAlign="center"
          value={formValues.amountCharged}
          onChange={handleOnChange}
          mb="2"
          py="10"
        />
        {invalidFieldsMessage[0] !== '' && (
          <span className="error">{invalidFieldsMessage[0]}</span>
        )}
      </Box>
      <Box color="gray.500" as="ul" px="4">
        <li>
          Se o valor ainda não apareceu na fatura, conclua a verificação depois.
          Se precisar de ajuda,
          <a
            href="https://uticket.com.br/ajuda/entre-em-contato?usuario=compradores"
            target="blank"
            style={{ textDecoration: 'none', color: 'blue' }}>
            {' '}
            entre em contato.
          </a>
        </li>
        <li>
          A cobrança será estornada automaticamente em 7 dias se a verificação
          não for concluída.
        </li>
        {/* <li>
          {
            'A cobrança será estornada após 7 dias caso a verificação não seja finaliza, caso queira cancelar a verificação e estornar agora '
          }
          <Button
            onClick={handleOnPressDelete}
            variant="link"
            bg="transparent"
            textDecoration="none"
            fontWeight="bold">
            clique aqui
          </Button>
        </li> */}
      </Box>
    </Box>
  );
};

export default CheckoutConfirmCard;
